module.exports = __webpack_public_path__ + "static/img/user_story4.5b60ff81.png";